import Retention from './src/main'
export default {
  install(Vue, props) {
    Vue.prototype.$RetentionModal = options => {
      Retention(options, props)
    }
  }
}
